import React, { useState } from 'react';
import './SearchFeatureContainer.css';
import AiSearch from './AiSearch';
import ConversationalSearch from './ConversationalSearch';
import PopularItemSearch from './PopularItemSearch';
import SearchFeatureContainerMenu from './SearchFeatureContainerMenu'


function SearchFeatureContainer({ requestConfig, keywordWeight }) {
  const [selectedFeature, setSelectedFeature] = useState('search');
  const [error, setError] = useState(null);


  const handleFeatureChange = (feature) => {
    setError(null);
    setSelectedFeature(feature);
  };

  const handleBackToStart = () => {
    setError(null);
    setSelectedFeature('search');
  };

  if (error) {
    return (
      <div className="search-feature-container">
        <div className="fatal-error">
          <h2>❌ Fehler</h2>
          <p>{error}</p>
          <button className="feature-btn error-back-button" onClick={handleBackToStart}>
            Zurück
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="search-feature-container">
      <SearchFeatureContainerMenu
        selectedFeature={selectedFeature}
        handleFeatureChange={handleFeatureChange}
      />
      {selectedFeature === 'search' && (
        <AiSearch requestConfig={requestConfig} keywordWeight={keywordWeight} setError={setError} />)
      }
      {selectedFeature === 'conversational' && (
        <ConversationalSearch requestConfig={requestConfig} setError={setError} />
      )}
      {selectedFeature === 'popular' && (
        <PopularItemSearch requestConfig={requestConfig} setError={setError} />
      )}
    </div>
  );
}

export default SearchFeatureContainer;